import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

import menu from './menu.module.js';
import poster from './poster.module.js';
import subscriptions from './subscriptions.module.js';
import compatibility from './compatibility.module.js';
import auditlog from './auditlog.module.js';
import worldwide from './worldwide.module.js';
import iiko from './iiko.module';
import ui from './ui.module';
import stoplist from './stoplist.module';
import integrations from './integrations.module';
import checklists from './checklists.module';

import AuthAPI from '@/api/auth';
import CafeAPI from '@/api/cafe';
import SubscriptionAPI from '@/api/subscription';
import BillingAPI from '@/api/billing';
import MarketplaceAPI from '@/api/marketplace';
import JoinAPI from '@/api/join';
import CurrencyAPI from '@/api/currency';
import PaymentAPI from '@/api/payment';
import WaitersAPI from '@/api/waiters';
import ChainAPI from '@/api/chain';

import moment from 'moment';
import SuperaccessService from '@/services/superaccess';

export default new Vuex.Store({
  state: {
    is_nav_panel_full_width: true,
    cafe: {
      name: 'Cafe Title',
      description: 'cafe description',
      image: 'https://placehold.it/100x100',
      preorder: {},
      delivery: {},
    },
    subscription: {
      plan: null,
      amount: 0,
      price: 0,
    },
    plans: {},
    owner: null,
    user_type: 'admin',
    billing_account: null,
    loggedIn: false,
    error: null,
    marketplace_enabled: false,
    intercom_hash: null,
    features: null,
    currency: {
      name: 'Українська гривня',
      code: 'грн.',
      symbol: '₴',
      iso_code: 'UAH',
    },
    waiters: null,
    pay_receivers: [],
    corporate_cafes: [],
    update_delta: [],
    chains: [],
    selected_chain: null,
    payment_menus_buffer: [],
  },
  mutations: {
    setNavPanelWidth(state, payload) {
      state.is_nav_panel_full_width = !state.is_nav_panel_full_width;
    },
    setCafe(state, payload) {
      state.cafe = payload;
    },
    setOwner(state, payload) {
      state.owner = payload;
      state.loggedIn = true;
    },
    setOwnerContacts(state, payload) {
      state.owner.name = payload.name;
      state.owner.phone = payload.phone;
      state.owner.image = payload.image;
    },
    setBillingAccount(state, payload) {
      state.billing_account = payload;
    },
    setIntercomHash(state, value) {
      state.intercom_hash = value;
    },
    logout(state, payload) {
      state.owner = null;
      state.loggedIn = false;
    },

    setError(state, code) {
      state.error = code;
    },

    toggleCafeMode(state, payload) {
      Vue.set(state.cafe.modes, payload.mode, payload.value);
      state.update_delta.push('modes');
    },

    setFeatures(state, payload) {
      state.features = payload;
    },

    setPaymentMenusBuffer(state, payload) {
      state.payment_menus_buffer = payload;
    },

    setPendingReviewsCount(state, payload) {
      state.owner.pending_reviews = payload;
    },

    setUserType(state, payload) {
      state.user_type = payload;
    },

    setChainModeMenu(state, payload) {
      const arr = state.selected_chain.menu_ids[payload.mode];

      if (!arr) Vue.set(state.selected_chain.menu_ids, payload.mode, []);

      if (payload.active) {
        arr.push(payload.menu_id);
      } else {
        Vue.set(
          state.selected_chain.menu_ids,
          payload.mode,
          arr.filter((id) => id != payload.menu_id)
        );
      }
    },

    setCafeModeMenu(state, payload) {
      if (payload.mode === 'inside') {
        const active = payload.active;

        if (!state.cafe.menu_ids) Vue.set(state.cafe, 'menu_ids', []);

        if (active) {
          const existing_index = state.cafe.menu_ids.indexOf(payload.menu_id);
          if (existing_index === -1) state.cafe.menu_ids.push(payload.menu_id);
        } else {
          state.cafe.menu_ids = state.cafe.menu_ids.filter(
            (id) => id != payload.menu_id
          );
        }
        state.update_delta.push('menu_ids');

        return;
      }

      if (payload.mode === 'preorder') {
        const active = payload.active;

        if (!state.cafe.preorder) Vue.set(state.cafe, 'preorder', {});
        if (!state.cafe.preorder.menu_ids)
          Vue.set(state.cafe.preorder, 'menu_ids', []);

        if (active) {
          const existing_index = state.cafe.preorder.menu_ids.indexOf(
            payload.menu_id
          );
          if (existing_index === -1)
            state.cafe.preorder.menu_ids.push(payload.menu_id);
        } else {
          state.cafe.preorder.menu_ids = state.cafe.preorder.menu_ids.filter(
            (id) => id != payload.menu_id
          );
        }
        state.update_delta.push('preorder');
        return;
      }

      if (payload.mode === 'delivery') {
        const active = payload.active;

        if (active) {
          const existing_index = state.cafe.delivery.menu_ids.indexOf(
            payload.menu_id
          );
          if (existing_index === -1)
            state.cafe.delivery.menu_ids.push(payload.menu_id);
        } else {
          state.cafe.delivery.menu_ids = state.cafe.delivery.menu_ids.filter(
            (id) => id != payload.menu_id
          );
        }
        state.update_delta.push('delivery');
      }

      if (payload.mode === 'hotels') {
        const active = payload.active;

        if (!state.cafe.hotels) Vue.set(state.cafe, 'hotels', {});
        if (!state.cafe.hotels.menu_ids)
          Vue.set(state.cafe.hotels, 'menu_ids', []);

        if (active) {
          state.cafe.hotels.menu_ids.push(payload.menu_id);
        } else {
          state.cafe.hotels.menu_ids = state.cafe.hotels.menu_ids.filter(
            (id) => id != payload.menu_id
          );
        }
        state.update_delta.push('hotels');
        return;
      }

      if (payload.mode === 'preview') {
        const active = payload.active;

        if (!state.cafe.preview) Vue.set(state.cafe, 'preview', {});
        if (!state.cafe.preview.menu_ids)
          Vue.set(state.cafe.preview, 'menu_ids', []);

        if (active) {
          state.cafe.preview.menu_ids.push(payload.menu_id);
        } else {
          state.cafe.preview.menu_ids = state.cafe.preview.menu_ids.filter(
            (id) => id != payload.menu_id
          );
        }
        state.update_delta.push('preview');
        return;
      }

      if (payload.mode === 'reserve') {
        Vue.set(state.cafe.reserve, 'menu_id', payload.menu_id);
        state.update_delta.push('reserve');
        return;
      }
    },

    removeMenuFromModes(state, payload) {
      if (state.cafe.delivery && state.cafe.delivery.menu_ids) {
        state.cafe.delivery.menu_ids = state.cafe.delivery.menu_ids.filter(
          (id) => id != payload
        );
      }

      if (state.cafe.preorder && state.cafe.preorder.menu_ids) {
        state.cafe.preorder.menu_ids = state.cafe.preorder.menu_ids.filter(
          (id) => id != payload
        );
      }

      if (state.cafe.menu_ids) {
        state.cafe.menu_ids = state.cafe.menu_ids.filter((id) => id != payload);
      }

      if (state.cafe.preview.menu_ids) {
        state.cafe.preview.menu_ids = state.cafe.preview.menu_ids.filter(
          (id) => id != payload
        );
      }

      state.update_delta.push('delivery');
      state.update_delta.push('menu_ids');
      state.update_delta.push('preorder');
      state.update_delta.push('preview');
    },

    removeMenuFromChain(state, payload) {
      Vue.set(
        state.selected_chain.menu_ids,
        'inside',
        state.selected_chain.menu_ids.inside.filter((id) => id != payload)
      );
      Vue.set(
        state.selected_chain.menu_ids,
        'preorder',
        state.selected_chain.menu_ids.preorder.filter((id) => id != payload)
      );
      Vue.set(
        state.selected_chain.menu_ids,
        'delivery',
        state.selected_chain.menu_ids.delivery.filter((id) => id != payload)
      );
      Vue.set(
        state.selected_chain.menu_ids,
        'preview',
        state.selected_chain.menu_ids.preview.filter((id) => id != payload)
      );
      Vue.set(
        state.selected_chain.menu_ids,
        'hotels',
        state.selected_chain.menu_ids.hotels.filter((id) => id != payload)
      );
    },

    patchCafeGeneralData(state, payload) {
      const keys = Object.keys(payload);

      for (const key of keys) {
        state.cafe[key] = payload[key];
      }

      state.update_delta.push(...keys);
    },

    setCafeGeneralData(state, payload) {
      Vue.set(state.cafe, 'name', payload.name);
      Vue.set(state.cafe, 'description', payload.description);
      // Vue.set(state.cafe, 'address', payload.address);
      // Vue.set(state.cafe, 'contact_phone', payload.contact_phone);
      // Vue.set(state.cafe, 'image', payload.image);
      // Vue.set(state.cafe, 'image_bg', payload.image_bg);
      // Vue.set(state.cafe, 'city', payload.city);
      // Vue.set(state.cafe, 'keywords', payload.keywords);
      Vue.set(state.cafe, 'price_level', payload.price_level);
      // Vue.set(state.cafe, 'online_menu_link', payload.online_menu_link);

      state.update_delta.push(
        'name',
        'description',
        'image',
        'image_bg',
        'price_level'
      );
    },

    setCafeContactData(state, payload) {
      // Vue.set(state.cafe, 'name', payload.name);
      // Vue.set(state.cafe, 'description', payload.description);
      Vue.set(state.cafe, 'address', payload.address);
      Vue.set(state.cafe, 'contact_phone', payload.contact_phone);
      // Vue.set(state.cafe, 'image', payload.image);
      Vue.set(state.cafe, 'city', payload.city);
      Vue.set(state.cafe, 'address_location', payload.address_location);
      // Vue.set(state.cafe, 'keywords', payload.keywords);
      // Vue.set(state.cafe, 'price_level', payload.price_level);
      // Vue.set(state.cafe, 'online_menu_link', payload.online_menu_link);
      state.update_delta.push(
        'address',
        'city',
        'address_location',
        'contact_phone'
      );
    },

    setCafeAddress(state, payload) {
      Vue.set(state.cafe, 'address', payload.address);
      Vue.set(state.cafe, 'city', payload.city);
      Vue.set(state.cafe, 'address_location', payload.address_location);
      state.update_delta.push('address', 'city', 'address_location');
    },

    setCafeContactPhone(state, payload) {
      Vue.set(state.cafe, 'contact_phone', payload);
      state.update_delta.push('contact_phone');
    },

    setCafeSections(state, payload) {
      Vue.set(state.cafe, 'sections', payload);
      state.update_delta.push('sections');
    },

    setCafeSection(state, { index, value }) {
      Vue.set(state.cafe.sections, index, value);
      state.update_delta.push('sections');
    },

    removeCafeSection(state, { index }) {
      Vue.delete(state.cafe.sections, index);
      state.update_delta.push('sections');
    },

    setCafeCloseTimeLimit(state, payload) {
      Vue.set(
        state.cafe[payload.mode],
        'close_time_limit',
        payload.close_time_limit
      );
      state.update_delta.push(payload.mode);
    },

    setSubscription(state, payload) {
      state.subscription = payload;
    },

    setPlans(state, payload) {
      state.plans = payload;
    },

    setCafeOnlineMenuLink(state, payload) {
      Vue.set(state.cafe, 'online_menu_link', payload);
      state.update_delta.push('online_menu_link');
    },

    setCafeOnlineMenuLinkModified(state, payload) {
      Vue.set(state.cafe, 'menu_link_modified', payload);
      state.update_delta.push('menu_link_modified');
    },

    setDeliveryCardNumber(state, payload) {
      Vue.set(state.cafe.delivery, 'card_number', payload);
    },

    setCafeOnboardingComplete(state, payload) {
      Vue.set(state.cafe, 'onboarding_complete', payload);
      state.update_delta.push('onboarding_complete');
    },

    setDeliveryCost(state, payload) {
      Vue.set(state.cafe.delivery, 'cost', payload.cost);
      Vue.set(state.cafe.delivery, 'cost_type', payload.cost_type);
      Vue.set(state.cafe.delivery, 'cost_min_check', payload.cost_min_check);
      Vue.set(
        state.cafe.delivery,
        'cost_conditional_type',
        payload.cost_conditional_type
      );
      Vue.set(
        state.cafe.delivery,
        'add_cost_to_check',
        payload.add_cost_to_check
      );

      state.update_delta.push('delivery');
    },

    setCafePackageCosts(state, payload) {
      Vue.set(state.cafe[payload.mode], 'package_costs', payload.package_costs);
      Vue.set(state.cafe[payload.mode], 'package_cost', payload.package_cost);
      Vue.set(
        state.cafe[payload.mode],
        'packaging_type',
        payload.packaging_type
      );
      state.update_delta.push(payload.mode);
    },

    addWorker(state, payload) {
      state.cafe.waiters.push({
        name: null,
        pin: `${Math.random() * 10000 + 1000}`,
      });
    },

    editWorkerName(state, payload) {
      Vue.set(state.cafe.waiters[payload.index], 'name', payload.value);
    },

    editWorkerPin(state, payload) {
      Vue.set(state.cafe.waiters[payload.index], 'pin', payload.value);
    },

    removeWorker(state, payload) {
      Vue.delete(state.cafe.waiters, payload.index);
    },

    setCafeWaiters(state, payload) {
      state.cafe.waiters = payload;
    },

    setCafeSchedule(state, payload) {
      state.cafe.schedule = payload;
      state.update_delta.push('schedule');
    },

    setCafeCallServices(state, payload) {
      Vue.set(state.cafe, 'call_services', payload);
      state.update_delta.push('call_services');
    },

    setCafeGeolocationMode(state, mode) {
      Vue.set(state.cafe, 'geolocation_mode', mode);
      state.update_delta.push('geolocation_mode');
    },

    setCafeGeneralLocation(state, payload) {
      Vue.set(state.cafe, 'location', payload);
      state.update_delta.push('location');
    },

    setCafePayMethods(state, payload) {
      const mode = payload.mode;
      const value = payload.pay_methods;

      if (mode == 'inside') {
        Vue.set(state.cafe, 'pay_methods', value);
        state.update_delta.push('pay_methods');
      } else {
        Vue.set(state.cafe[mode], 'pay_methods', value);
        state.update_delta.push(mode);
      }
    },

    setCafePayReceiver(state, payload) {
      const mode = payload.mode;
      const value = payload.pay_receiver;

      if (mode == 'inside') {
        Vue.set(state.cafe, 'pay_receiver', value);
      } else {
        Vue.set(state.cafe[mode], 'pay_receiver', value);
      }
    },

    setDeliverySchedule(state, payload) {
      Vue.set(state.cafe.delivery, 'schedule', payload);
      state.update_delta.push('delivery');
    },

    setDeliveryGeolocation(state, payload) {
      Vue.set(state.cafe.delivery, 'geolocation', payload);
      state.update_delta.push('delivery');
    },

    setDeliveryGeolocationZones(state, payload) {
      Vue.set(state.cafe.delivery, 'geolocations', payload);
      state.update_delta.push('delivery');
    },

    setDeliveryMinCheck(state, payload) {
      Vue.set(state.cafe.delivery, 'min_check', payload);
      state.update_delta.push('delivery');
    },

    setDeliveryContactPhone(state, payload) {
      Vue.set(state.cafe.delivery, 'contact_phone', payload);
      state.update_delta.push('delivery');
    },

    setDeliveryPayMethods(state, payload) {
      Vue.set(state.cafe.delivery, 'pay_methods', payload);
      state.update_delta.push('delivery');
    },

    setDeliveryAddressDetails(state, payload) {
      Vue.set(state.cafe.delivery, 'address_details', payload);
      state.update_delta.push('delivery');
    },

    setPreorderPayMethods(state, payload) {
      Vue.set(state.cafe.preorder, 'pay_methods', payload);
      state.update_delta.push('preorder');
    },

    setPreorderContactPhone(state, payload) {
      Vue.set(state.cafe.preorder, 'contact_phone', payload);
      state.update_delta.push('preorder');
    },

    setPreorderSchedule(state, payload) {
      Vue.set(state.cafe.preorder, 'schedule', payload);
      state.update_delta.push('preorder');
    },

    setPreorderCardNumber(state, payload) {
      Vue.set(state.cafe.preorder, 'card_number', payload);
      state.update_delta.push('preorder');
    },

    setPreorderMinOrderTime(state, payload) {
      Vue.set(state.cafe.preorder, 'min_order_time', payload);
      state.update_delta.push('preorder');
    },

    setModeMinOrderTime(state, payload) {
      Vue.set(state.cafe[payload.mode], 'min_order_time', payload.value);
      state.update_delta.push(payload.mode);
    },

    setPreorderAllowReservation(state, payload) {
      Vue.set(state.cafe.preorder, 'allow_reservation', payload);
      state.update_delta.push('preorder');
    },

    setPreorderAllowTakeaway(state, payload) {
      Vue.set(state.cafe.preorder, 'allow_takeaway', payload);
      state.update_delta.push('preorder');
    },

    setInitialPreorder(state, payload) {
      if (!state.cafe.preorder) {
        Vue.set(state.cafe, 'preorder', {
          menu_ids: [],
          schedule: {},
          pay_methods: {
            cash: false,
            online: false,
          },
          contact_phone: null,
          card_number: null,
        });
        state.update_delta.push('preorder');
      }
    },

    setLoyaltySettings(state, payload) {
      state.cafe.loyalty = payload;
      state.update_delta.push('loyalty');
    },

    setPosterSetting(state, payload) {
      Vue.set(state.cafe.poster, payload.key, payload.value);
      state.update_delta.push('poster');
    },

    removePosterMenu(state, payload) {
      if (state.cafe.poster && state.cafe.poster.menu_id == payload) {
        Vue.set(state.cafe.poster, 'menu_id', null);
      }
    },

    setReservePrice(state, payload) {
      Vue.set(state.cafe.reserve, 'reservation_price', payload);
      state.update_delta.push('reserve');
    },
    setReservePayReceiver(state, payload) {
      Vue.set(state.cafe.reserve, 'pay_receiver_id', payload);
      state.update_delta.push('reserve');
    },

    setInsideSelfService(state, payload) {
      Vue.set(state.cafe, 'self_service', payload);
      state.update_delta.push('self_service');
    },
    setReserveMaxGuests(state, payload) {
      Vue.set(state.cafe.reserve, 'max_guests_count', payload);
      state.update_delta.push('reserve');
    },
    setReserveMaxDays(state, payload) {
      Vue.set(state.cafe.reserve, 'max_days', payload);
      state.update_delta.push('reserve');
    },
    setReserveSameDayAllowed(state, payload) {
      Vue.set(state.cafe.reserve, 'allow_same_day', payload);
      state.update_delta.push('reserve');
    },
    setReserveDepositSettings(state, { value, type, enabled, percent }) {
      Vue.set(state.cafe.reserve, 'deposit_value', value || 0);
      Vue.set(state.cafe.reserve, 'deposit_type', type);
      Vue.set(state.cafe.reserve, 'deposit_enabled', enabled);
      Vue.set(state.cafe.reserve, 'deposit_percent', percent);
      state.update_delta.push('reserve');
    },
    setReserveUsePhoneVerification(state, payload) {
      Vue.set(state.cafe.reserve, 'use_phone_verification', payload);
      state.update_delta.push('reserve');
    },
    setMarketplaceEnabled(state, payload) {
      state.marketplace_enabled = payload;
      state.update_delta.push('marketplace_enabled');
    },
    setMarketplaceMode(state, payload) {
      Vue.set(state.cafe.marketplace_modes, payload.mode, payload.value);
      state.update_delta.push('marketplace_modes');
    },
    setMarketplaceAgreed(state, payload) {
      Vue.set(state.cafe, 'marketplace_agreed', payload);
      state.update_delta.push('marketplace_agreed');
    },
    setInsideLite(state, payload) {
      Vue.set(state.cafe, 'inside_lite', payload);
      state.update_delta.push('inside_lite');
    },
    setOwnerTwoFactorAuth(state, payload) {
      Vue.set(state.owner.two_factor_auth, 'enabled', payload);
    },
    setFoodFlavors(state, payload) {
      Vue.set(state.cafe, 'food_flavors', payload);
      state.update_delta.push('food_flavors');
    },
    setCurrency(state, payload) {
      state.currency = payload;
    },
    setCafeCurrencyId(state, payload) {
      Vue.set(state.cafe, 'currency_id', payload);
      state.update_delta.push('currency_id');
    },
    setCafeSocial(state, payload) {
      Vue.set(state.cafe, 'social', {
        instagram: payload.instagram,
        facebook: payload.facebook,
        website: payload.website,
      });
      state.update_delta.push('social');
    },
    setCafeTimezone(state, payload) {
      Vue.set(state.cafe, 'timezone', payload);
      state.update_delta.push('timezone');
    },
    resetNotificationsCount(state) {
      state.owner.pending_notifications = 0;
    },
    setCorporateCafes(state, payload) {
      state.corporate_cafes = payload;
    },
    setDeliveryServiceData(state, payload) {
      state.cafe.delivery.service_tag = payload.service_tag;
      state.cafe.delivery.service_status = payload.service_status;
      state.update_delta.push('delivery');
    },
    setDeliveryTaxiPayer(state, payload) {
      Vue.set(state.cafe.delivery, 'taxi_payer', payload);
      state.update_delta.push('delivery');
    },
    setDeliveryCostMinCheck(state, payload) {
      Vue.set(state.cafe.delivery, 'cost_min_check', payload);
      state.update_delta.push('delivery');
    },
    setDeliveryCostMinChecks(state, payload) {
      Vue.set(state.cafe.delivery, 'cost_min_checks', payload);
      state.update_delta.push('delivery');
    },
    setDeliverySmartFlag(state, payload) {
      Vue.set(state.cafe.delivery, 'is_smart', payload);
      state.update_delta.push('delivery');
    },
    setServingFeePercent(state, payload) {
      Vue.set(state.cafe.serving_fee, 'percent', payload);
      state.update_delta.push('serving_fee');
    },
    setServingFeeMode(state, payload) {
      Vue.set(state.cafe.serving_fee.modes, payload.mode, payload.value);
      state.update_delta.push('serving_fee');
    },
    setTaxesFeePercent(state, payload) {
      Vue.set(state.cafe, 'taxes_fee', payload);
      state.update_delta.push('taxes_fee');
    },
    setDeliveryShippingTime(state, payload) {
      Vue.set(state.cafe.delivery, 'shipping_time', payload);
      state.update_delta.push('delivery');
    },
    setDeliveryCourierDelay(state, payload) {
      Vue.set(state.cafe.delivery, 'courier_reminder_delay', payload);
      state.update_delta.push('delivery');
    },
    setDeliveryUseGuestsCount(state, payload) {
      Vue.set(state.cafe.delivery, 'use_guests_count', payload);
      state.update_delta.push('delivery');
    },
    setPreorderUseGuestsCount(state, payload) {
      Vue.set(state.cafe.preorder, 'use_guests_count', payload);
      state.update_delta.push('preorder');
    },
    setPayReceivers(state, payload) {
      state.pay_receivers = payload;
    },
    setFacebookPixelId(state, payload) {
      Vue.set(state.cafe, 'facebook_pixel_id', payload);
      state.update_delta.push('facebook_pixel_id');
    },
    setIikoSettings(state, payload) {
      Vue.set(state.cafe, 'iiko', payload);
      state.update_delta.push('iiko');
    },
    setWaiters(state, payload) {
      state.waiters = payload;
    },
    setPosterSyncOptions(state, payload) {
      Vue.set(state.cafe.poster, 'sync_menu', payload.sync_menu);
      Vue.set(state.cafe.poster, 'sync_waiters', payload.sync_waiters);
      Vue.set(state.cafe.poster, 'sync_tables', payload.sync_tables);
      Vue.set(state.cafe.poster, 'sync_storage', payload.sync_storage);
      Vue.set(
        state.cafe.poster,
        'sync_transactions',
        payload.sync_transactions
      );
      state.update_delta.push('poster');
    },
    setModeMotd(state, payload) {
      const container =
        payload.mode == 'inside' ? state.cafe : state.cafe[payload.mode];
      Vue.set(container, 'motd', payload.value);
      state.update_delta.push(payload.mode == 'inside' ? 'motd' : payload.mode);
    },
    setModeButtonTitle(state, payload) {
      const container =
        payload.mode == 'inside' ? state.cafe : state.cafe[payload.mode];
      Vue.set(container, 'ui_button_title', payload.value);
      state.update_delta.push(
        payload.mode == 'inside' ? 'ui_button_title' : payload.mode
      );
    },
    setChains(state, payload) {
      state.chains = payload;
    },
    selectChain(state, payload) {
      state.selected_chain = payload;
    },
    setChainData(state, payload) {
      Vue.set(state.selected_chain, payload.key, payload.value);
    },
    setChainSetting(state, payload) {
      Vue.set(state.selected_chain.settings, payload.key, payload.value);
    },
    setCafeSecurity(state, payload) {
      Vue.set(state.cafe, 'security', payload);
      state.update_delta.push('security');
    },
    setTablePosition(state, payload) {
      Vue.set(
        state.cafe.sections[payload.section_index].tables_list[
          payload.table_index
        ],
        'x_pos',
        payload.x_pos
      );

      Vue.set(
        state.cafe.sections[payload.section_index].tables_list[
          payload.table_index
        ],
        'y_pos',
        payload.y_pos
      );

      state.update_delta.push('sections');
    },
    setTableSize(state, payload) {
      Vue.set(
        state.cafe.sections[payload.section_index].tables_list[
          payload.table_index
        ],
        'width',
        payload.width
      );

      Vue.set(
        state.cafe.sections[payload.section_index].tables_list[
          payload.table_index
        ],
        'height',
        payload.height
      );

      state.update_delta.push('sections');
    },
    addTable(state, payload) {
      state.cafe.sections[payload.section_index].tables++;
      state.cafe.sections[payload.section_index].tables_list.push({
        name: '',
        places_count: 1,
        x_pos: 4,
        y_pos: 4,
        width: 4,
        height: 4,
      });
      state.update_delta.push('sections');
    },
    setRoundMenuPrices(state, value) {
      state.cafe.round_menu_prices = value;
      state.update_delta.push('round_menu_prices');
    },
    setCutleryPrice(state, { mode, price }) {
      Vue.set(state.cafe[mode], 'cutlery_price', price);
      state.update_delta.push(mode);
    },
    setReminderTimeout(state, value) {
      Vue.set(state.cafe, 'order_reminder_timeout', value);
      state.update_delta.push('order_reminder_timeout');
    },
    setPreorderTimeFlag(state, value) {
      Vue.set(state.cafe.preorder, 'allow_specific_time', value);
      state.update_delta.push('preorder');
    },
    setAutoCancelTimeout(state, { mode, value }) {
      const container = mode == 'inside' ? state.cafe : state.cafe[mode];

      Vue.set(container, 'auto_cancel_timeout', value);
      state.update_delta.push(mode == 'inside' ? 'auto_cancel_timeout' : mode);
    },
    clearUpdateDelta(state) {
      state.update_delta = [];
    },

    setClientAppData(state, { key, value }) {
      state.update_delta.push('client_app');

      Vue.set(state.cafe.client_app, key, value);
    },

    setOwnerDashboardLanguage(state, lang) {
      Vue.set(state.owner, 'dashboard_language', lang);
    },
    addCafeCloseRule(state, payload) {
      state.cafe.close_rules.push(payload);
      Vue.set(
        state.cafe,
        'close_rules',
        state.cafe.close_rules.filter((it) =>
          moment().isBetween(it.start_date, it.end_date, null, '[]')
        )
      );
      state.update_delta.push('close_rules');
    },
    clearCafeCloseRulesForSystem(state, system) {
      Vue.set(
        state.cafe,
        'close_rules',
        state.cafe.close_rules.filter((it) => it.system != system)
      );
      state.update_delta.push('close_rules');
    },
    setTipMode(state, mode) {
      Vue.set(state.cafe.tips, 'mode', mode);
      state.update_delta.push('tips');
    },
    setTipPayReceiverId(state, id) {
      Vue.set(state.cafe.tips, 'pay_receiver_id', id);
      state.update_delta.push('tips');
    },
    setTipSystemEnabled(state, { system, enabled }) {
      Vue.set(state.cafe.tips.modes, system, enabled);
      state.update_delta.push('tips');
    },
    setTipsEnabled(state, mode) {
      Vue.set(state.cafe.tips, 'enabled', mode);
      state.update_delta.push('tips');
    },
  },
  modules: {
    menu,
    poster,
    subscriptions,
    compatibility,
    auditlog,
    worldwide,
    iiko,
    ui,
    stoplist,
    integrations,
    checklists,
  },
  actions: {
    fetchCafe(context, payload) {
      return new Promise((resolve, reject) => {
        const promise = payload
          ? CafeAPI.getCafeById(payload)
          : CafeAPI.getMyCafe();

        promise
          .then((data) => {
            context.commit('setCafe', data.cafe);

            console.log('fetched');

            context.dispatch('fetchCurrency');
            context.dispatch('fetchPayReceivers');

            context.dispatch('subscriptions/fetchAll', data.cafe._id);
            context.dispatch(
              'integrations/fetchCatalogue',
              context.state.worldwide.region_code
            );
            context.dispatch('integrations/fetchConnected', {
              cafe_id: data.cafe._id,
            });

            context.dispatch('fetchWaiters');

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchPayReceivers(context, payload) {
      return new Promise((resolve, reject) => {
        PaymentAPI.getPayReceivers(context.state.cafe._id)
          .then((data) => {
            context.commit('setPayReceivers', data.pay_receivers);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchCorporateCafes(context, payload) {
      return new Promise((resolve, reject) => {
        CafeAPI.getCorporateList()
          .then((data) => {
            context.commit('setCorporateCafes', data.cafes);
            context.commit('setChains', data.chains);

            if (context.state.selected_chain) {
              const chain = data.chains.find(
                (ch) => ch._id == context.state.selected_chain._id
              );

              console.log(chain);

              if (chain) {
                context.commit('selectChain', chain);
              }
            }

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchSubscription(context) {
      return new Promise((resolve, reject) => {
        SubscriptionAPI.getInfo()
          .then((data) => {
            const subscription = data.subscription;
            subscription.price = data.price;
            context.commit('setSubscription', subscription);
          })
          .catch((error) => {
            reject(error);
          });

        SubscriptionAPI.getPlans()
          .then((data) => {
            context.commit('setPlans', data.plans);
          })
          .catch((error) => {
            // reject(error);
          });
      });
    },
    fetchWaiters(context) {
      return new Promise((resolve, reject) => {
        WaitersAPI.getCafeWaiters(context.state.cafe._id)
          .then((data) => {
            context.commit('setWaiters', data.waiters);
          })
          .catch((error) => {
            context.commit('setWaiters', []);
          });
      });
    },
    fetchBilling(context) {
      return new Promise((resolve, reject) => {
        BillingAPI.getAccount()
          .then((data) => {
            context.commit('setBillingAccount', data.account);
          })
          .catch((error) => {
            context.dispatch('showError', 'billing_fetch');
            reject(error);
          });
      });
    },
    fetchChains(context) {
      return new Promise((resolve, reject) => {
        ChainAPI.getChains()
          .then((data) => {
            context.commit('setChains', data.chains);
            resolve();
          })
          .catch((err) => {
            context.dispatch('showError', 'chains_error');
            reject(error);
          });
      });
    },
    saveCafe(context) {
      return new Promise((resolve, reject) => {
        const cafe = context.state.cafe;

        const update_object = {
          owner_id: cafe.owner_id,
          _id: cafe._id,
          primary_category: cafe.primary_category,
        };

        for (const path of context.state.update_delta) {
          update_object[path] = cafe[path];
        }

        CafeAPI.updateCafeById(context.state.cafe._id, update_object)
          .then((data) => {
            resolve();

            context.commit('clearUpdateDelta');
          })
          .catch((error) => {
            context.dispatch('showError', 'cafe_save', {
              root: true,
            });
            // alert(`Сталася помилка при збереженні інформації про заклад! Будь ласка, оновіть сторінку або зв'яжіться з тех. підтримкою.`);
            reject(error);
            context.commit('clearUpdateDelta');
          });
      });
    },
    init(context, payload) {
      return new Promise((resolve, reject) => {
        AuthAPI.me()
          .then((data) => {
            if (!data.session) {
              reject();
              return;
            }

            context.commit('setUserType', data.session.type);
            context.commit('setOwner', data.user);

            context.commit('setIntercomHash', data.intercom_hash);

            if (data.session.type == 'admin') {
              context.dispatch('fetchBilling');
            }

            context
              .dispatch('fetchCorporateCafes')
              .then(() => {
                let target_cafe_id = null;

                const last_cafe_id = window.localStorage.getItem(
                  'dashboard_last_cafe'
                );

                if (
                  last_cafe_id &&
                  context.state.corporate_cafes.find(
                    (c) => c._id == last_cafe_id
                  )
                ) {
                  // if (!context.state.selected_chain) {
                  //     context.dispatch('switchCafe', last_cafe_id).then(resolve).catch(reject);
                  // } else {
                  //     resolve();
                  // }
                  target_cafe_id = last_cafe_id;
                } else {
                  window.localStorage.removeItem('dashboard_last_cafe');
                }

                if (payload) target_cafe_id = payload;

                context
                  .dispatch('fetchCafe', target_cafe_id)
                  .then(() => {
                    context.dispatch('integrations/fetchConnected', {
                      cafe_id: context.state.cafe._id,
                    });

                    resolve();
                  })
                  .catch(reject);
              })
              .catch(reject);

            context.dispatch('worldwide/init', data.user.country);

            setTimeout(() => {
              context.dispatch('bootIntercom');
            }, 500);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    login(context, payload) {
      return new Promise((resolve, reject) => {
        AuthAPI.login(payload.email, payload.password)
          .then((data) => {
            if (data.two_factor_required) {
              resolve(data);
              return;
            }

            context
              .dispatch('init')
              .then(resolve)
              .catch(reject);
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    },
    loginTwoFactor(context, payload) {
      return new Promise((resolve, reject) => {
        AuthAPI.confirmTwoFactorLogin(payload.token, payload.code)
          .then((data) => {
            context
              .dispatch('init')
              .then(resolve)
              .catch(reject);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    logout(context, payload) {
      return new Promise((resolve, reject) => {
        AuthAPI.logout()
          .then((ok) => {
            context.commit('logout');
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    activateDelivery(context, payload) {
      return new Promise((resolve, reject) => {
        CafeAPI.activateDelivery(payload)
          .then((data) => {
            context.commit('setCafe', data.cafe);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkMarketplaceCity(context, payload) {
      return new Promise((resolve, reject) => {
        MarketplaceAPI.checkCity(context.state.cafe.city)
          .then((data) => {
            const value =
              data.marketplace_enabled && context.state.cafe._id <= 120;
            context.commit('setMarketplaceEnabled', value);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchFeatures(context, payload) {
      return new Promise((resolve, reject) => {
        JoinAPI.getFeatures()
          .then((data) => {
            context.commit('setFeatures', data.features);

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchCurrency(context, payload) {
      return new Promise((resolve, reject) => {
        if (!context.state.cafe.currency_id) {
          resolve();
          return;
        }

        CurrencyAPI.getById(context.state.cafe.currency_id)
          .then((data) => {
            context.commit('setCurrency', data.currency);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            reject(error);
          });
      });
    },
    switchCafe(context, payload) {
      if (!payload.from_chain) {
        context.commit('selectChain', null);
        return context.dispatch('fetchCafe', payload);
      } else {
        return context.dispatch('fetchCafe', payload.cafe_id);
      }
    },
    saveChain(context, payload) {
      return new Promise((resolve, reject) => {
        ChainAPI.updateChain(
          context.state.selected_chain._id,
          context.state.selected_chain
        )
          .then((data) => {
            context.dispatch('fetchCorporateCafes');

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    showError(context, payload) {
      context.commit('ui/addToast', {
        variant: 'error',
        content: payload,
      });
    },
    bootIntercom(context, payload) {
      const intercomOpts = {};

      const superadmin_sessions = SuperaccessService.get();

      if (window.location.href.includes('staging.')) {
        return;
      }

      if (context.state.loggedIn) {
        const owner = context.state.owner;
        const cafe = context.state.cafe;

        intercomOpts.email = owner.email;
        intercomOpts.name = owner.name || owner.email;
        intercomOpts.user_id = owner._id;
        intercomOpts.user_hash = context.state.intercom_hash;
        intercomOpts.phone = owner.phone;
        intercomOpts.company = {
          id: cafe.qId,
          internal_id: cafe._id,
          name: cafe.name || cafe.qId,
          created_at: moment(cafe.registered).unix(),
          address: cafe.address,
        };

        if (superadmin_sessions) {
          intercomOpts.email = `root@qrwaiter.com.ua`;
          intercomOpts.name = `QRWaiter Team`;
          intercomOpts.user_id = `superuser_id`;
          delete intercomOpts.company;
          intercomOpts.user_hash =
            '6b0df8eee9ae67d9c7f7f3f243fce503c2082311fc67e94af0cf46db4a1bd7c4';
        }

        intercomOpts['Source Platform'] = 'Web';
      }

      window.Intercom('boot', {
        app_id: 'rsh7gloh',
        ...intercomOpts,
      });
    },
  },
  getters: {
    is_nav_panel_full_width(state) {
      return state.is_nav_panel_full_width;
    },
    checkSubscriptionPermission(state) {
      return (perm) => {
        const plan = state.subscription.plan;

        if (!state.plans[plan]) return false;

        return state.plans[plan].permissions.includes(perm);
      };
    },
    isSubscriptionActive(state) {
      return (
        state.subscription &&
        state.subscription.plan &&
        state.subscription.amount
      );
    },
    onlineMenuLink(state) {
      return (mode, link_override) => {
        mode = mode || 'delivery';
        return `https://cafe.qrwaiter.com.ua/${link_override ||
          state.cafe.online_menu_link}`;
      };
    },
    isDeliveryActivated(state) {
      return state.cafe.delivery && state.cafe.delivery.service_tag;
    },
    readyPayReceiver(state) {
      // const pay_receiver = state.cafe.pay_receiver;

      // if (!pay_receiver) return false;

      // if (pay_receiver.type == 'card' && !pay_receiver.card_number) return false;
      // if (pay_receiver.type == 'bank_account' && !pay_receiver.account) return false;
      // if (pay_receiver.type == 'liqpay_merchant' && !pay_receiver.liqpay_public_key) return false;
      // if (pay_receiver.type == 'wayforpay_merchant' && !pay_receiver.wayforpay_merchant) return false;

      return state.pay_receivers.length > 0;
    },
    readyPayment(state, getters) {
      return (mode) => {
        const container = mode == 'inside' ? state.cafe : state.cafe[mode];

        if (!container.pay_methods) return false;

        const at_least_one =
          container.pay_methods.cash ||
          container.pay_methods.card ||
          container.pay_methods.online;
        // const receiver_valid = container.pay_receiver.type == 'bank_account' ? !!container.pay_receiver.account : !!container.pay_receiver.card_number;

        if (container.pay_methods.online) {
          if (!getters.readyPayReceiver) return false;
        }

        return at_least_one;
      };
    },
    readySchedule(state) {
      return (
        state.cafe.schedule &&
        Object.values(state.cafe.schedule).filter(
          (d) =>
            d.workday &&
            d.startHour !== null &&
            d.endHour !== null &&
            d.endMinute !== null &&
            d.startMinute !== null
        ).length >= 1
      );
    },
    readyWaiters(state) {
      return state.waiters && state.waiters.length;
    },
    readyNotifications(state) {
      return (
        state.cafe.notifications &&
        (state.cafe.notifications.telegram || state.cafe.notifications.ios_app)
      );
    },
    readyDelivery(state, getters) {
      if (!state.cafe || !state.cafe.delivery) return {};

      const ready = {
        enable: true,
        menu: !!state.cafe.chain_id || !!state.cafe.delivery.menu_ids.length,
        payment: getters.readyPayment('delivery'),
        address: !!state.cafe.address,
        schedule: getters.readySchedule,
        geolocation: state.cafe.delivery.geolocations.length,
      };

      ready.subtotal =
        ready.menu && ready.payment && ready.schedule && ready.address;

      ready.total = ready.subtotal;

      return ready;
    },
    readyPreorder(state, getters) {
      if (!state.cafe || !state.cafe.preorder) return {};

      const ready = {
        enable: true,
        menu:
          !!state.cafe.chain_id ||
          (!!state.cafe.preorder.menu_ids &&
            !!state.cafe.preorder.menu_ids.length),
        payment: getters.readyPayment('preorder'),
        schedule: getters.readySchedule,
      };

      ready.subtotal = ready.menu && ready.payment && ready.schedule;

      ready.total = ready.subtotal;

      return ready;
    },

    readyPreview(state, getters) {
      if (!state.cafe) return {};

      const ready = {
        enable: true,
        schedule: getters.readySchedule,
        menu:
          !!state.cafe.chain_id ||
          (!!state.cafe.preview.menu_ids &&
            !!state.cafe.preview.menu_ids.length),
      };

      ready.subtotal = ready.menu && ready.schedule;

      ready.total = ready.subtotal;

      return ready;
    },

    readyInsideLite(state, getters) {
      if (!state.cafe) return {};

      if (state.cafe.inside_lite) {
        const ready = {
          menu: !!state.cafe.menu_ids && !!state.cafe.menu_ids.length,
          stickers: state.cafe.activated,
          subscription: getters['subscriptions/isSubscriptionActive'](
            'inside_lite'
          ),
        };

        ready.subtotal = ready.menu && ready.stickers;

        ready.total = ready.total && ready.subscription;

        return ready;
      }
    },

    readyInside(state, getters) {
      if (!state.cafe) return {};

      const ready = {
        enable: true,
        menu:
          !!state.cafe.chain_id ||
          (!!state.cafe.menu_ids && !!state.cafe.menu_ids.length),
        payment: getters.readyPayment('inside'),
        schedule: getters.readySchedule,
        tables: state.cafe.sections && state.cafe.sections.length,
      };

      ready.subtotal =
        ready.menu && ready.payment && ready.schedule && ready.tables;

      ready.total = ready.subtotal;

      return ready;
    },

    readyReserveTables(state) {
      const first_section = state.cafe.sections.find((s) => {
        if (!s.tables_list) return;
        const first_table = s.tables_list.find(
          (t) => t.for_reserve && t.places_count
        );

        return !!first_table;
      });

      return !!first_section;
    },

    readyReserve(state, getters) {
      if (!state.cafe) return {};

      const ready = {
        enable: true,
        // notifications: getters.readyNotifications,
        tables: getters.readyReserveTables,
        schedule: getters.readySchedule,
        // subscription: getters['subscriptions/isSubscriptionActive']('reserve'),
      };

      ready.subtotal = ready.schedule && ready.tables;
      ready.total = ready.subtotal;

      return ready;
    },

    deliveryPartner(state) {
      return state.cafe.delivery.service_tag === 'qrwaiter'
        ? null
        : state.cafe.delivery.service_tag;
    },

    hasPosterIntegration(state) {
      return state.cafe.poster && state.cafe.poster.access_token;
    },

    hasIikoIntegration(state) {
      return state.cafe.iiko && state.cafe.iiko.front_token;
    },

    currentPosSystem(state, getters) {
      if (getters.hasPosterIntegration) return 'poster';
      if (getters.hasIikoIntegration) return 'iiko';

      return null;
    },

    atLastOneModeActive(state) {
      if (!state.cafe || !state.cafe.modes) return false;
      return (
        state.cafe.modes.inside ||
        state.cafe.modes.preorder ||
        state.cafe.modes.delivery ||
        state.cafe.modes.reserve
      );
    },

    checkFeature(state) {
      return (type) => {
        if (!state.features) return false;

        return state.features[type] || false;
      };
    },

    checkFeatureSystem(state) {
      return (type) => {
        if (!state.features) return false;

        if (type == 'delivery' && state.cafe._id == 126) {
          return true;
        }

        if (type == 'preorder' && state.cafe._id == 126) {
          return true;
        }

        return state.features.systems.includes(type);
      };
    },

    getCorporateCafe(state) {
      return (id) => {
        return state.corporate_cafes.find((c) => c._id == id);
      };
    },

    checkUserPemission(state) {
      return (perm) => {
        if (!perm) return true;
        if (state.user_type == 'admin') return true;

        const perms_container = state.owner.permissions[state.cafe._id];

        if (!perms_container) return false;

        return (
          perms_container.includes(perm.toLowerCase()) ||
          perms_container.includes('*')
        );
      };
    },

    isEmployeeSession(state) {
      return state.user_type != 'admin';
    },

    isInDemoMode(state, getters, rootState) {
      if (!rootState.subscriptions) return false;

      const preorder_sub = rootState.subscriptions.preorder;
      const delivery_sub = rootState.subscriptions.preorder;

      let flag = false;

      if (preorder_sub.trial_period_until) {
      }
    },

    isHotel(state) {
      return state.cafe && state.cafe.primary_category == 'hotel';
    },

    isUsingServiceReservations(state) {
      //TODO: change later if needed
      return (
        state.cafe && state.cafe.reserve && state.cafe.reserve.use_superapp
      );
    },

    getChain(state) {
      return (id) => {
        return state.chains.find((c) => c._id == id);
      };
    },

    currentCafeChain(state, getters) {
      return getters.getChain(state.cafe.chain_id);
    },

    chainCafes(state) {
      return (id) => {
        if (!state.selected_chain && !id) return [];
        return state.corporate_cafes.filter(
          (c) => c.chain_id == (id || state.selected_chain._id)
        );
      };
    },

    checkBillingPlanForPaidService(state) {
      return (service) => {
        const cafe = state.cafe;

        if (cafe.billing.trial_until && !cafe.billing.paid_until) {
          if (moment(cafe.billing.trial_until).isAfter(moment())) {
            return true;
          }
        }

        if (cafe.billing.paid_until) {
          if (moment(cafe.billing.paid_until).isBefore(moment())) {
            return false;
          }
        }

        if (
          service === 'preview' &&
          ['dynamic', 'smart'].includes(cafe.billing.selected_plan)
        )
          return true;

        if (cafe.billing.selected_plan === 'smart') return true;

        return cafe.billing.selected_services.includes(service);
      };
    },

    getAvailableSystemsForUsage(state, getters) {
      const all = ['preview', 'inside', 'takeaway', 'delivery'];

      const available = all.map((sys) =>
        getters.checkBillingPlanForPaidService(sys)
      );

      return available;
    },

    getCloseRuleForSystem(state) {
      return (system) => {
        return state.cafe.close_rules.find(
          (r) =>
            r.system == system && moment().isBetween(r.start_date, r.end_date)
        );
      };
    },
  },
});
